import { Box, Fade, Modal, Typography } from "@mui/material";
import React, { useEffect, useRef } from 'react';
import FlexBox from "../styledComponents/FlexBox";
import { DMStyles } from "styles/Styles";

export const AccountHoldModal = ({ open }) => {
  const blockerRef = useRef(null);

  // This is just to prevent user's from hiding the modal backdrop 
  // via CSS and reaccessing the blocked app. 
  // If detected, it signals to refresh the page so it comes back again.
  useEffect(() => {
    setInterval(() => {
      const modalElements = document.getElementsByClassName("MuiModal-root");
    
      if (modalElements?.length) {
        const backdrop = modalElements[0];
        if (!!backdrop && !backdrop.checkVisibility({visibilityProperty: true, opacityProperty: true, contentVisibilityAuto: true})) {
          window.location.reload();
        }
      }
    }, 2000);
  }, []);

  return (
    <Modal
      ref={blockerRef}
      open={open}
      aria-labelledby={`account-hold-modal-title`}
      aria-describedby={`account-hold-modal-description`}
    >
      <Fade in={open}>
        <Box 
          sx={{
            width: "auto", 
            minWidth: "25%",
            maxWidth: "75%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "var(--whiteColor)",
            padding: "0 !important"
            }}
          >
          <FlexBox
            alignItems={"center"}
            gap={0.5}
            justifyContent={"space-between"}
          >
            <Box display={"flex"} flexDirection={"column"} width={"100%"}>
              <Box
                width={"100%"}
                padding={"10px"}
                bgcolor={"#A80000"}
                display={"flex"}
                flexWrap={"wrap"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                  borderTopLeftRadius: ".25rem",
                  borderTopRightRadius: ".25rem",
                }}
              >
                <Typography
                  color={DMStyles.White}
                  fontWeight={"bold"}
                  fontSize={"20px"}
                >
                  Account On Hold!
                </Typography>
              </Box>
              <Box width={"100%"} padding={"1rem"} display="flex" justifyContent="center" flexWrap="wrap">
                <Typography
                  marginY=".5rem"
                  whiteSpace="pre-wrap"
                  textAlign="center"
                  textWrap="auto"
                >
                  Your community currently has a subscription invoice that needs attention.{'\n'}
                  Please contact us at 800.544.3059 ext. 826{'\n'}
                  Once resolved, your account will be fully reactivated.          
                </Typography>
              </Box>
            </Box>
          </FlexBox>
        </Box>
      </Fade>
    </Modal>
  );
};
